import { render } from "./ProposalCompletedPurchasesPage.vue?vue&type=template&id=522ce166"
import script from "./ProposalCompletedPurchasesPage.vue?vue&type=script&lang=js"
export * from "./ProposalCompletedPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__